import { all, call } from "redux-saga/effects"
import { shopSagas } from "./shop/shopSagas"
import { userSagas } from "./user/userSagas"
import { cartSagas } from "./cart/cartSagas"

export default function* rootSata() {
  yield all([call(userSagas), call(cartSagas), call(shopSagas)])
}
